// drop-down.js
// todo: close on click
;(({ log, isSameOrChild, getAllParentsWithClass }) => {
    const allDd = document.querySelectorAll('.drop-down')
    const activeClass = 'drop-down--active'

    allDd.forEach(dd => {
        const clickSwitch = parseInt(dd.dataset.ddClickSwitch) || 0
        const cancelOthers = dd.dataset.ddCancelOthers == 'true'
        const deactivateDelay = parseInt(dd.dataset.ddDeactivateDelay) || 0

        // get only our trigger, not for children
        const trigger = dd.querySelectorAll('.drop-down__trigger')[0]

        let deactivateTimer = null
        
        // hover
        dd.addEventListener('mouseenter', e => {
            if (!allowHover(clickSwitch)) return

            clearTimeout(deactivateTimer)

            if (cancelOthers) {
                closeOtherDd([dd])
            }

            dd.classList.add(activeClass)
        })

        // unhover
        dd.addEventListener('mouseleave', e => {
            if (!allowHover(clickSwitch)) return

            deactivateTimer = setTimeout(() => {
                dd.classList.remove(activeClass)
            }, deactivateDelay)
        })

        if (trigger) {
            trigger.addEventListener('click', e => {
                e.stopPropagation()
                if (!allowClick(clickSwitch)) return

                CNS.$fns.closeTouchPanel()

                if (dd.classList.contains(activeClass)) {
                    closeAllDd()
                } else {
                    const preventList = getAllParentsWithClass(dd, 'drop-down')
                    preventList.push(dd)
    
                    closeOtherDd(preventList)
                    dd.classList.add(activeClass)
                }
            })
        }

        window.addEventListener('click', e => {
            e.stopPropagation()
            if (!isSameOrChild(dd, e.target)) {
                closeAllDd()
            }
        })
    })

    function allowHover(clickSwitch) {
        return window.innerWidth > clickSwitch
    }

    function allowClick(clickSwitch) {
        return !allowHover(clickSwitch)
    }

    function closeOtherDd(preventList) {
        allDd.forEach(dd => {
            if (![...preventList].includes(dd)) {
                dd.classList.remove(activeClass)
            }
        })
    }

    function closeAllDd() {
        allDd.forEach(d => {
            d.classList.remove(activeClass)
        })
    }

    
})(CNS);